<template>
  <v-container class="pa-0 fill-height" fluid>
    <v-row class="fill-height">
      <v-col class="d-flex justify-center align-center">
        <v-card class="mx-auto" max-width="500">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-alert type="error">
                  <span class="font-weight-bold">
                    Kirjautumisesi on vanhentunut
                  </span> <br/>
                  Palaa sivulle sähköpostissasi olevan linkin kautta. <br/>
                </v-alert>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "NotAuthenticatedView",
}
</script>

<style scoped>

</style>
